module.exports = __webpack_public_path__ + "img/bonhomme-contact.209c9e97.svg";